import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Mount React inside custom element
function mountReactApp(element) {
  const formId = element.getAttribute("form-id") || "default";
  
  const root = ReactDOM.createRoot(element);
  root.render(<App formId={formId} />);
}

class AjivasanApp extends HTMLElement {

  static get observedAttributes() {
    return ["form-id"];
  }

  connectedCallback() {
    mountReactApp(this);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "form-id" && newValue !== oldValue) {
      mountReactApp(this);
    }
  }
}

// Define only once to avoid WordPress duplicate errors
if (!customElements.get("ajivasan-app")) {
  customElements.define("ajivasan-app", AjivasanApp);
}
